<template>
    <section>
        <section id="music" class="tw-pt-12 tw-mb-12 tw-border-b tw-relative">
            <div class="gradient" :style="{'background-color': bgColor}"></div>
            <div class="tw-container tw-mx-auto tw-relative">
                <div class="tw-flex tw-w-full tw-flex-col md:tw-flex-row tw-items-center">
                    <v-img aspect-ratio="1/1" id="coverImg" :src="spotify.album.images[0].url" class="tw-py-2 tw-shadow-lg tw-rounded-sm" height="180" width="180"></v-img>
                    <div class="md:tw-ml-8 tw-py-4 tw-flex tw-flex-col tw-justify-between middle">
                        <div class="tw-items-start tw-text-left tw-flex tw-flex-col tw-w-full">
                            <div class="tw-justify-center md:tw-justify-start tw-flex tw-items-center tw-w-full">
                                <div @click="togglePlay()" class="tw-w-10 tw-h-10 tw-bg-purple-400 tw-shadow-md tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-cursor-pointer" v-ripple>
                                    <i class="fas tw-absolute tw-text-sm" :class="{'fa-pause': playing, 'fa-play': !playing}"></i>
                                </div>
                                <h3 class="tw-font-sans tw-text-white tw-text-2xl md:tw-text-3xl lg:tw-text-4xl xl:tw-text-5xl tw-font-extrabold tw-m-0 tw-ml-4 tw-truncate">{{spotify.name}}</h3>
                            </div> 
                            <div class="tw-flex tw-items-center tw-justify-center md:tw-justify-start tw-w-full tw-truncate">
                                <a href="#!" class="tw-font-sans tw-text-white tw-text-sm lg:tw-text-base tw-font-bold tw-m-0 tw-mt-2 tw-tracking-tighter tw-ml-1 tw-truncate" v-for="(artist, index) in spotify.artists" :key="artist.id">
                                    <span>{{artist.name}}</span>
                                    <span v-if="index !== spotify.artists.length - 1" class="dot"></span>
                                </a>
                            </div>
                        </div>
                        <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-mt-5 tw-justify-center md:tw-justify-start">
                            <div v-if="single"><a :href="single.sharedlink" v-if="single && single.sharedlink.length" target="_blank" v-ripple class="tw-px-4 tw-py-2 tw-bg-white tw-rounded-sm tw-font-sans tw-text-black tw-text-xs tw-tracking-wide tw-uppercase">{{preSave ? (selectedLanguageObj.pre_save) : (selectedLanguageObj.listen)}}</a></div>
                            <div class="tw-flex tw-mt-3 md:tw-mt-0 tw-items-center">
                                <span class="dot tw-mx-2 tw-hidden md:tw-block" v-if="single && single.sharedlink.length"></span>
                                <div class="tw-font-sans tw-text-white tw-font-semibold tw-text-sm">
                                    {{getReleaseYear()}}
                                </div>
                                <span class="dot tw-mx-2"></span>
                                <v-dialog v-model="dialog" max-width="450" transition="scroll-y-transition">
                                    <template v-slot:activator="{ on }">
                                        <v-btn class="tw-border-white" v-on="on" fab light outlined x-small color="white">
                                            <v-icon class="tw-text-sm">fas fa-share-alt</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-toolbar dark color="purple">
                                            <v-btn icon dark small class="tw-ml-1" @click="dialog = false">
                                                <v-icon class="tw-text-sm">fas fa-times</v-icon>
                                            </v-btn>
                                            <v-toolbar-title class="tw-font-sans tw-pl-2">{{selectedLanguageObj.share}}</v-toolbar-title>
                                        </v-toolbar>
                                        <div class="tw-px-2 tw-py-4">
                                            <div class="tw-px-2">
                                                <div class="tw-flex tw-items-center tw-flex-wrap tw--mx-2">
                                                    <div class="tw-w-full md:tw-w-1/2 tw-px-2">
                                                        <v-btn target="_blank" :href="shareLinks['facebook']" block dark outlined class="tw-font-sans tw-text-xs tw-relative tw-mb-3">
                                                            <v-icon right dark class="tw-text-sm tw-absolute tw-left-0 tw--ml-1">fab fa-facebook</v-icon>
                                                            Facebook
                                                        </v-btn>
                                                    </div>
                                                    <div class="tw-w-full md:tw-w-1/2 tw-px-2">
                                                        <v-btn target="_blank" :href="shareLinks['twitter']" block dark outlined class="tw-font-sans tw-text-xs tw-relative tw-mb-3">
                                                            <v-icon right dark class="tw-text-sm tw-absolute tw-left-0 tw--ml-1">fab fa-twitter</v-icon>
                                                            Twitter
                                                        </v-btn>
                                                    </div>
                                                    <div class="tw-w-full md:tw-w-1/2 tw-px-2">
                                                        <v-btn target="_blank" :href="shareLinks['whatsapp']" block dark outlined class="tw-font-sans tw-text-xs tw-relative tw-mb-3 md:tw-mb-0">
                                                            <v-icon right dark class="tw-text-sm tw-absolute tw-left-0 tw--ml-1">fab fa-whatsapp</v-icon>
                                                            Whatsapp
                                                        </v-btn>
                                                    </div>
                                                    <div class="tw-w-full md:tw-w-1/2 tw-px-2">
                                                        <v-btn target="_blank" :href="'mailto:?subject=Olha essa música!&amp;body=Olha essa música que encontrei na MusicPro: '+currentUrl" block dark outlined class="tw-font-sans tw-text-xs tw-relative">
                                                            <v-icon right dark class="tw-text-sm tw-absolute tw-left-0 tw--ml-1">fas fa-envelope</v-icon>
                                                            E-Mail
                                                        </v-btn>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <v-divider></v-divider>
                                        <div class="tw-px-4 tw-py-4">
                                            <div class="tw-w-full tw-flex tw-items-center tw-py-2 tw-px-3 tw-border tw-rounded tw-justify-between" id="shareLink">
                                                <input type="text" :value="currentUrl" readonly class="tw-opacity-0 tw-absolute tw-top-0 tw-w-2" id="pen-url">
                                                <div class="tw-mr-4 tw-text-sm tw-font-light tw-truncate tw-font-sans tw-opacity-40 tw-cursor-default tw-pointer-events-none">{{ currentUrl }}</div>
                                                <button @click="copyText()" class="tw-h-full tw-px-6 tw-py-2 tw-inline-flex tw-items-center tw-justify-center tw-text-white tw-font-sans tw-uppercase tw-text-xs tw-whitespace-no-wrap tw-rounded" v-ripple>{{selectedLanguageObj.copy}}</button>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-dialog>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tw-w-full tw-mt-10 tw-px-5 md:tw-px-0">
                    <div id="waves"></div>
                </div>
            </div>
            <v-tabs v-model="tab" background-color="transparent" color="white" centered dark class="tw-mt-6 tw-font-sans">
                <v-tabs-slider></v-tabs-slider>

                <v-tab class="tw-text-xs" href="#recomended">
                    {{selectedLanguageObj.recommendations}}
                </v-tab>

                <v-tab class="tw-text-xs" href="#lyrics" @v-on:click="readMore()">
                    {{selectedLanguageObj.lyrics}}
                </v-tab>

                <v-tab class="tw-text-xs" href="#info">
                    {{selectedLanguageObj.info}}
                </v-tab>
            </v-tabs>
        </section>
        <div class="tw-container tw-mx-auto tw-pb-12">
            <v-tabs-items v-model="tab" id="tabs" touchless reverse class="tw-bg-transparent">
                <v-tab-item id="recomended">
                    <div class="swiper-container tw-w-full tw-mt-5">
                        <!-- Additional required wrapper -->
                        <div class="swiper-wrapper">
                            <!-- Slides -->
                            <single class="swiper-slide" v-for="(music, index) in related" :key="index" :single="music" :artist="artist" />                              
                        </div>
                    </div>
                </v-tab-item>
                <v-tab-item id="lyrics">
                    <p class="tw-font-sans tw-text-white tw-font-light truncated tw-px-4 md:tw-px-0 tw-whitespace-pre-wrap" v-if="single ? (single.letra == '' && !single.letra) : !single">Nenhuma letra cadastrada</p>
                    <p class="tw-font-sans tw-text-white tw-font-light truncated tw-px-4 md:tw-px-0 tw-whitespace-pre-wrap" v-if="single ? (single.letra !== '' && single.letra) : false" v-html="single.letra"></p>
                </v-tab-item>
                <v-tab-item id="info">
                    <div class="tw-px-4 md:tw-px-0 tw-font-sans tw-text-white tw-font-light">
                        <h6 class="tw-mb-5">{{selectedLanguageObj.info_tech}}</h6>
                        <p class="tw-font-bold tw-mb-0" v-if="single">{{single.trackArtist}}</p>
                        <p class="tw-font-bold tw-mb-0" v-if="!single">
                            <span v-for="(artist, index) in spotify.artists" :key="index">
                                {{artist.name}}
                                <span v-if="index !== spotify.artists.length - 1" class="tw-mr-1">,</span>
                            </span>
                        </p>
                        <p class="tw-text-sm">{{selectedLanguageObj.autors}}</p>
                        <!-- <p class="tw-font-bold tw-mb-0">Mufazza</p>
                        <p class="tw-text-sm">Produtor</p> -->
                        <h6 class="tw-mb-5 tw-mt-10">{{selectedLanguageObj.info}}</h6>
                        <p class="tw-font-bold tw-mb-0" v-if="single">{{selectedLanguageObj.main_genre}}</p>
                        <p class="tw-text-sm" v-if="single">{{single.primaryGenre}}</p>
                        <p class="tw-font-bold tw-mb-0" v-if="single">{{selectedLanguageObj.secondary_genre}}</p>
                        <p class="tw-text-sm" v-if="single">{{single.secundaryGenre}}</p>
                        <p class="tw-font-bold tw-mb-0">{{selectedLanguageObj.code_ISRC}}</p>
                        <p class="tw-text-sm">{{spotify.external_ids.isrc}}</p>
                        <p class="tw-font-bold tw-mb-0" v-if="single">{{selectedLanguageObj.code_UPC}}</p>
                        <p class="tw-text-sm" v-if="single">{{single.upc}}</p>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </div>
        <v-snackbar v-model="snackBar" class="tw-font-sans tw-font-light">
            {{selectedLanguageObj.info_close}}
            <v-btn color="red" text @click="snackBar = false">{{selectedLanguageObj.close}}</v-btn>
        </v-snackbar>
    </section>
</template>

<script>
import Layout from '@/Shared/SingleLayout';
import WaveSurfer from 'wavesurfer.js';
import moment from 'moment';
import rgbaster from 'rgbaster'
window.moment = global.moment = moment;
window.rgbaster = global.rgbaster = rgbaster;
import Swiper from 'swiper';
import EventBus from '@/eventbus';
import Single from '@/components/single';
import pt from '../lang/single.js';

require('readmore-js');

export default {
    mixins: [pt],
    layout: (h, page) => h(Layout, [page]),
    layout: Layout,
    metaInfo() {
        return {
            title: `${this.spotify.name}`,
        }
    },
    props: ['spotifyArtist', 'spotify', 'single', 'related', 'artist', 'shareLinks', 'pageOptions'],
    components: {Single},
    data(){
        return{
            tab: null,
            bgColor: '',
            playing: false,
            loading: false,
            waves: '',
            dialog: false,
            currentUrl: '',
            snackBar: false,
            selectedLanguageObj: {}
        }
    },
    computed: {
        preSave(){
            const release_date = moment(this.spotify.album.release_date);
            const today = moment();
            console.log(release_date, today);
            if(release_date > today) return true
            return false; 
        },
    },
    methods: {
        copyText(){
            var copyText = document.querySelector("#pen-url");
            copyText.select();
            document.execCommand("copy")
            this.snackBar = true;
        },
        getReleaseYear(){
            return moment(this.spotify.album.release_date, 'YYYY-MM-DD').format('YYYY');
        },
        readMore(){
            setTimeout(() => {
                $('#lyrics p').addClass('truncated')
                $('#lyrics p').readmore({
                    moreLink: '<a href="#" class="readmore tw-font-sans tw-text-center tw-block md:tw-text-left tw-text-white">Ler Mais</a>',
                    lessLink: '<a href="#" class="readmore--close tw-font-sans tw-text-center tw-block md:tw-text-left tw-text-white">Fechar</a>',
                    collapsedHeight: 150, 
                    beforeToggle: function(trigger, el, ex) {
                        if(ex){
                            $('#lyrics p').addClass('truncated')
                        } else {
                            $('#lyrics p').removeClass('truncated')
                        }
                    } 
                });
            }, 100);
        },
        togglePlay(){
            this.waves.playPause();
        },
        setLanguage() {
            if(this.$page.props.lang == 'US') {
                this.selectedLanguageObj = pt.data().en
            } else {
                this.selectedLanguageObj = pt.data().pt
            }
        }
    },
    created(){
        this.currentUrl = window.location;
    },
    mounted(){
        this.setLanguage();
        const vm = this;
        setTimeout(() => {
            EventBus.$emit('artist', {'pageOptions': this.pageOptions, 'artist': this.artist, 'spotifyArtist': this.spotifyArtist});
        }, 10);
        
        this.waves = WaveSurfer.create({
            container: '#waves',
            waveColor: '#6d6b69',
            progressColor: '#784399',
            normalize: true,
            barWidth: 5,
            barHeight: 1,
            hideScrollbar:true,
            barRadius: 3,
            responsive:true,
            cursorColor: 'transparent',
            barGap: 4, // the optional spacing between bars of the wave, if not provided will be calculated in legacy format
        });
        this.waves.load(this.spotify.preview_url);

        this.$nextTick(() => {

            setTimeout(() => {
                var recomendedSwiper = new Swiper('#tabs .swiper-container', {
                    slidesPerView: 2.25,
                    slidesPerGroup: 1,
                    spaceBetween: 15,
                    slidesOffsetBefore: 15,
                    slidesOffsetAfter: 15,
                    observer: true,
                    observeParents: true,
                    observeSlideChildren:true,
                    navigation: {
                        nextEl: '#tabs .swiper-button-next',
                        prevEl: '#tabs .swiper-button-prev',
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 5,
                            slidesPerGroup: 5,
                            slidesPerColumn: 2,
                            slidesPerColumnFill: 'row',
                            slidesOffsetBefore: 0,
                            slidesOffsetAfter: 0,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 5,
                            slidesPerGroup: 5,
                            slidesPerColumn: 2,
                            slidesPerColumnFill: 'row',
                            slidesOffsetBefore: 0,
                            slidesOffsetAfter: 0,
                            spaceBetween: 20,
                        },
                        1280: {
                            slidesPerView: 5,
                            slidesPerColumn: 2,
                            slidesPerColumnFill: 'row',
                            slidesPerGroup: 5,
                            slidesOffsetBefore: 0,
                            slidesOffsetAfter: 0,
                            spaceBetween: 20,
                        },
                    },
                });
            }, 1);
        });

        this.waves.on('play', function(){
            vm.playing = true;
        });

        this.waves.on('pause', function(){
            vm.playing = false;
        });
        
        async function color(){
            const result = await rgbaster(vm.spotify.album.images[0].url);
            console.log(result);
            vm.bgColor = result[0].color;
        }
        color();
    }
}
</script>

<style scoped>
    .middle{
        width: calc(100% - 40px);
    }
    @media (min-width: 768px){
        .middle{
            width: calc(100% - 180px - 2rem);
        }
    }
    .dot::before{
        content: "\2022";
        margin: 0 4px;
    }
    #waves{
        height: 64px;
        overflow: hidden;
    }
    #music{
        border-color: #6d6b692b;
    }
    .gradient{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        margin: 0;
        background: linear-gradient(to bottom,rgba(0,0,0,.3),rgba(27,27,27,.56) 45%,#1f1f1f);
        transition: background-color .2s ease-in-out;
    }
    #lyrics p{
        transition: all 0.5s ease 0s;
    }
    #lyrics p.truncated{
        /* -webkit-mask-image: -webkit-gradient(linear, left -50%, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)))!important; */
    }
    #lyrics p.truncated::before{
        content: '' !important;
        position: absolute !important;
        top: 0 !important;
        width: 100% !important;
        height: 100% !important;
        border-bottom: 1px solid #eee !important;
    }
    #lyrics p{
        height: auto;
        overflow: hidden !important;
    }
    #shareLink{
        border-color: rgba(255, 255, 255, 0.12)!important;
    }
</style>